import { mergeDeep, isDev } from './index'

const fetch = require('isomorphic-fetch')

const AGENT_DOMAIN = 'https://rainbow.ambientweather.net'
// const AGENT_DOMAIN = 'http://localhost:3022' // For local development, change as needed
const AGENT_SERVER = AGENT_DOMAIN + (isDev() ? '/dev' : '') + '/agent/'

/**
 * Base fetch function for all AWN agent API calls
 * @param {string} path - API endpoint path
 * @param {Object} options - Fetch options
 * @param {boolean} returnFullResponse - If true, returns the full response object instead of just JSON
 * @returns {Promise<Object>} - Response data or full response object
 */
async function _fetchAgentApi(path, options = {}, returnFullResponse = false) {
  const url = AGENT_SERVER + path
  const jwt = localStorage.getItem('feathers-jwt')
  
  try {
    const defaultOptions = {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    }
    
    // Merge default options with provided options
    const fetchOptions = mergeDeep(defaultOptions, options)
    
    const response = await fetch(url, fetchOptions)
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    
    if (returnFullResponse) {
      return response
    }
    
    return response.json()
  } catch (error) {
    _handleError(error)
    throw error
  }
}

function _handleError(error) {
  console.error('AWN Agent API Error:', error)
}

/**
 * Helper function to check if response was successful (status 200-299)
 * @param {Response} response - Fetch response object
 * @returns {boolean} - Whether the response was successful
 */
function isSuccessResponse(response) {
  return response && response.status >= 200 && response.status <= 299
}

/**
 * POST request to AWN agent API
 * @param {string} path - API endpoint path
 * @param {Object} data - Data to post
 * @returns {Promise<Object>} - Response data
 */
export async function postAgentApi(path, data) {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }
  
  return _fetchAgentApi(path, options)
}